import { EEecsPackageDeliveryDeadline, EEecsPackageStatus, EEecsPackageType } from '../types/eecs-package.types';

export const EecsPackageTypeMap = {
  [EEecsPackageType.INCOMING]: {
    name: 'Incoming',
    tooltip: 'Incoming package sent to you by the counterparty',
    styles: 'bg-appLightGreen text-black',
  },
  [EEecsPackageType.OUTGOING]: {
    name: 'Outgoing',
    tooltip: 'Outgoing package you sent to the counterparty',
    styles: 'bg-appLightBlue text-black',
  },
};

export const EecsPackageStatusMap = {
  [EEecsPackageStatus.PENDING]: {
    name: 'Pending',
    tooltip: 'Awaiting confirmation',
    styles: 'bg-appCreamy text-black',
  },
  [EEecsPackageStatus.IN_PROGRESS]: {
    name: 'In Progress',
    tooltip: 'Package is being processed',
    styles: 'bg-appLightYellow text-black',
  },
  [EEecsPackageStatus.CANCELLED]: {
    name: 'Cancelled',
    tooltip: 'Package was cancelled',
    styles: 'bg-appRed text-black',
  },
  [EEecsPackageStatus.NO_PAYMENT]: {
    name: 'No Payment',
    tooltip: 'Awaiting payment',
    styles: 'bg-appOrange text-black',
  },
  [EEecsPackageStatus.DELIVERED]: {
    name: 'Delivered',
    tooltip: 'Package was delivered',
    styles: 'bg-appLightGreen text-black',
  },
};
export const EEecsPackageDeliveryDeadlineMap = {
  [EEecsPackageDeliveryDeadline.ONE_DAY]: {
    name: '1 day',
  },
  [EEecsPackageDeliveryDeadline.TWO_DAYS]: {
    name: '2 days',
  },
  [EEecsPackageDeliveryDeadline.THREE_DAYS]: {
    name: '3 days (default)',
  },
  [EEecsPackageDeliveryDeadline.FOUR_DAYS]: {
    name: '4 days',
  },
  [EEecsPackageDeliveryDeadline.FIVE_DAYS]: {
    name: '5 days',
  },
  [EEecsPackageDeliveryDeadline.SIX_DAYS]: {
    name: '6 days',
  },
  [EEecsPackageDeliveryDeadline.ONE_WEEK]: {
    name: '1 week',
  },
  [EEecsPackageDeliveryDeadline.TWO_WEEKS]: {
    name: '2 weeks',
  },
};
